var map = {
	"./Vector.png": 800,
	"./alert.png": 801,
	"./arrowup.png": 802,
	"./binance.png": 803,
	"./coin98.png": 331,
	"./ethereum.png": 804,
	"./matic-org.png": 805,
	"./matic.png": 806,
	"./metamask.png": 332,
	"./moonriver.png": 807,
	"./onto.png": 333,
	"./portisIcon.png": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;